import { render, staticRenderFns } from "./QuestionRecommendationDialog.vue?vue&type=template&id=028611ad"
import script from "./QuestionRecommendationDialog.vue?vue&type=script&lang=js"
export * from "./QuestionRecommendationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports